import { PageName, PAGES } from "./Pages";

export const DEFAULT_POSTS_PAGE_SIZE = 24;
export const DEFAULT_UPCOMING_PAGE_SIZE = 10;

export const getInitialPostsPageSize = (page: PageName) =>
  page === PAGES.UPCOMING
    ? DEFAULT_UPCOMING_PAGE_SIZE
    : DEFAULT_POSTS_PAGE_SIZE;

export const getReloadPostsPageSize = ({
  currentPage,
  page,
  pageSize,
}: {
  currentPage?: number | null;
  page: PageName;
  pageSize?: number | null;
}) =>
  page === PAGES.UPCOMING
    ? DEFAULT_UPCOMING_PAGE_SIZE *
      (currentPage && currentPage > 0 ? currentPage : 1)
    : (pageSize ?? DEFAULT_POSTS_PAGE_SIZE);
